import { AxiosAdapter as CoreAxiosAdapter } from '@core/adapters';
import { ROUTE_NAME } from '@constants';
import { AxiosResponse } from 'axios';
import { isArray } from 'lodash-es';

export class AxiosAdapter extends CoreAxiosAdapter {
  async handle400Error(
    errorMessage: string,
    errorCode: string,
    error: AxiosResponse
  ) {
    console.error('400 Bad Request Error', error);
    if (errorCode === 'NO_PASSWORD') {
      if (!(await this.alertStore.showConfirmDialog(errorMessage))) {
        return;
      }
      await this.router.push({ name: ROUTE_NAME.NewPasswordAccount });
    } else if (errorCode === 'SNS_ACCOUNT') {
      // SNS 간편가입 회원이 직접 로그인을 시도한 경우:
      // 비밀번호 재설정으로 보내지 않고, SNS 로그인 사용 안내만 표시한다.
      await this.alertStore.showAlertDialog(errorMessage);
    } else if (isArray(error.data.data)) {
      throw error;
    } else {
      await this.alertStore.showAlertDialog(errorMessage);
    }
  }
}
